import React from 'react';
import PropTypes from 'prop-types';
import { exportImage } from '../../../../../../tokens/js/utils/exportImage';
import './exportbuttons.scss';

const ExportButtons = (props) => {
  const { chartContainer, useLegacyDownloader, configString, apiUrl } = props;

  const isFirefox =
    window.navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
  const isAndroid =
    window.navigator.userAgent.toLowerCase().indexOf('android') > -1;

  const execExport = (event, exportFunction = null) => {
    const { target } = event;

    document.body.style.cursor = 'wait';
    target.style.cursor = 'wait';

    exportFunction(
      chartContainer.current,
      () => {
        document.body.style.cursor = 'auto';
        target.style.cursor = 'pointer';
      },
      configString,
      apiUrl
    );
  };

  return isFirefox && isAndroid ? (
    <></>
  ) : (
    <div className="downloadBtn-container">
      <button
        type="button"
        onClick={(event) => execExport(event, exportImage.toPNGNew)}
        className="downloadBtn"
      >
        PNG
      </button>
      {!useLegacyDownloader && (
        <button
          type="button"
          onClick={(event) => execExport(event, exportImage.toSVG)}
          className="downloadBtn"
        >
          SVG
        </button>
      )}
      {useLegacyDownloader && (
        <button
          type="button"
          onClick={(event) => execExport(event, exportImage.toSVGLegacy)}
          className="downloadBtn"
        >
          SVG
        </button>
      )}
      <button
        type="button"
        onClick={(event) => execExport(event, exportImage.toPDF)}
        className="downloadBtn"
      >
        PDF
      </button>
    </div>
  );
};

ExportButtons.propTypes = {
  chartContainer: PropTypes.oneOfType([
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]).isRequired,
  useLegacyDownloader: PropTypes.bool,
  configString: PropTypes.string,
  apiUrl: PropTypes.string,
};

ExportButtons.defaultProps = {
  useLegacyDownloader: false,
  configString: '',
  apiUrl: '',
};

export default ExportButtons;
